import { render, staticRenderFns } from "./Bindofficialaccountdia.vue?vue&type=template&id=1942a3a7&scoped=true"
import script from "./Bindofficialaccountdia.vue?vue&type=script&lang=js"
export * from "./Bindofficialaccountdia.vue?vue&type=script&lang=js"
import style0 from "./Bindofficialaccountdia.vue?vue&type=style&index=0&id=1942a3a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942a3a7",
  null
  
)

export default component.exports